
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1152:971)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#8200FF"}})]),_c('path',{attrs:{"d":"M19.556 27.3h8.555c.206 0 .404-.1.55-.278.146-.178.228-.42.228-.672 0-.252-.082-.494-.228-.672a.714.714 0 00-.55-.278H21.89c-1.031 0-2.02-.5-2.75-1.391S18 21.909 18 20.65c0-1.26.41-2.468 1.139-3.359.73-.89 1.719-1.391 2.75-1.391h1.555V14h3.112v1.9h3.888v3.8H21.89c-.206 0-.404.1-.55.278-.146.178-.228.42-.228.672 0 .252.082.494.228.672a.714.714 0 00.55.278h6.222c1.031 0 2.02.5 2.75 1.391S32 25.091 32 26.35c0 1.26-.41 2.468-1.139 3.359-.73.89-1.719 1.391-2.75 1.391h-1.555V33h-3.112v-1.9h-3.888v-3.8z","fill":"#fff"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1152:971","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1152:971"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1152:971","result":"shape"}})])])])
          )
        }
      }
    